<template>
	<section id="global" class="section section--alt">
		<div class="container">
			<header v-reveal class="section__head">
				<p class="section__eyebrow">{{ t('global.eyebrow') }}</p>
				<h2 class="section__title">
					<span class="marker">{{ t('global.title') }}</span>
				</h2>
				<p class="section__subtitle">{{ t('global.subtitle') }}</p>
				<p class="section__body">{{ t('global.body') }}</p>
			</header>

			<figure v-reveal class="global__map">
				<img
					:src="assetUrl('world-map.webp')"
					:alt="t('global.map-alt')"
					width="1600"
					height="1063"
					loading="lazy"
				>
			</figure>

			<div v-reveal class="global__countries">
				<p class="global__countries-title">{{ t('global.countries-title') }}</p>
				<ul class="global__country-list">
					<li
						v-for="key in COUNTRY_KEYS"
						:key="key"
						class="global__country"
					>{{ t(`global.countries.${key}`) }}</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { COUNTRY_KEYS } from '@/helpers/constants'
import { assetUrl } from '@/helpers/functions'

defineOptions({ name: 'GlobalSection' })

const { t } = useI18n()
</script>

<style scoped lang="scss">
.global__map {
	margin: 0;

	img {
		width: 100%;
		height: auto;
	}
}

.global__countries {
	margin-top: clamp(20px, 3vw, 34px);
	text-align: center;
}

.global__countries-title {
	font-size: 0.78rem;
	font-weight: 600;
	letter-spacing: 0.2em;
	text-transform: uppercase;
	color: $color-muted;

	@include arabic {
		letter-spacing: 0.06em;
	}
}

.global__country-list {
	margin-top: 18px;
	display: flex;
	flex-wrap: wrap;
	gap: 9px;
	justify-content: center;
}

.global__country {
	padding: 7px 16px;
	background: $color-paper;
	border: 1px solid $color-line;
	border-radius: 999px;
	font-size: 0.86rem;
	font-weight: 500;
	color: $color-ink;

	&::before {
		content: '';
		display: inline-block;
		width: 6px;
		height: 6px;
		margin-inline-end: 8px;
		vertical-align: 0.12em;
		border-radius: 50%;
		background: $color-gold-deep;
	}
}
</style>
